<template>
  <a class="wrappericon" :href="url">
    <img class="pdf_icon" src="https://www.uma.pt/wp-content/themes/uma/images/pdf_icon.png" />
    {{ nome }}
  </a>
</template>

<script>
export default {
  props: ["url", "nome"]
};
</script>

<style scoped>
.wrappericon {
  padding-bottom: 22px;
  border: 1px solid #6eb7ec;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Montserrat SemiBold";
  color: #6eb7ec;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  padding-left: 5px;
  padding-right: 5px;
}

.wrappericon:hover {
  border: 1px solid #488ec1;
  color: #488ec1;
}

.pdf_icon {
  height: 32px;
  width: 27px;
  display: block;
  margin-top: 10px;
  margin-bottom: 8px;
}


@media (max-width:767px) {

  .wrappericon,
  .wrappericon:hover {
    border: 0;
  }

  .wrappericon {
    text-align: left;
    flex-direction: row;
  }

  .pdf_icon {
    margin-right: 8.3px;
    margin-left: 3.266px;
    margin-top: 0;
  }

  .img_regulamento_doc {
    padding-top: 7px;
  }

  .img_regulamento_doc a {
    padding-left: 0px !important;
  }

  .img_regulamento_doc .pdf_icon {
    margin-left: 0px;
    margin-top: 0px;
    width: 28px;
  }
}
</style>